<template>
  <iframe
    v-if="canOpen === 'can_open' && srcUrl !== ''"
    width="100%"
    style="height: calc(100vh - 7px);"
    :src="'/pdfjs/web/viewerWithDownloadAndPrint.html?file=' + srcUrl"
    id="viewer"
  />
  <iframe
    v-else-if="srcUrl !== ''"
    width="100%"
    style="height: calc(100vh - 7px);"
    :src="'/pdfjs/web/viewer.html?file=' + srcUrl"
  />
  <div v-else-if="srcUrl === ''" style="display: grid; margin-top: 25px;">
    <h5 style="justify-self: center;">Молимо сачекајте, фајл се учитава...</h5>
  </div>
</template>

<script>
import axios from "axios";

import { mapActions, mapState } from "vuex";
import * as helper from "@/utils/helper-methods";

export default {
  name: "SlglrsPDFJSViewer",
  props: [],
  data() {
    return {
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      srcUrl: "",
      linkForDownload: "",
    };
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        return "can_open";
      } else {
        return "not_logged_in";
      }
    },
  },
  async mounted() {
    this.setShowLayout(false);

    var self = this;
    if (this.$route.query.fromLink === "true") {
      await axios
        .get(
          this.baseSLGLApiUrl +
            "prins/viewdoc?uuid=" +
            this.$route.params.actId,
          { responseType: "blob" }
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.linkForDownload = document.createElement("a");

          const fileurl = URL.createObjectURL(blob);
          this.linkForDownload.href = fileurl;

          this.$nextTick(() => {
            this.srcUrl = fileurl;
            this.hideChat();
          });
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            window.location.href = "/";
          }
        });
    } else {
      await axios
        .get(
          this.baseSLGLApiUrl +
            "Prins/GetPdfById?id=" +
            this.$route.params.actId,
          { responseType: "blob" }
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.linkForDownload = document.createElement("a");

          const fileurl = URL.createObjectURL(blob);
          this.linkForDownload.href = fileurl;

          this.$nextTick(() => {
            this.srcUrl = fileurl;
            this.hideChat();
          });

          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            window.location.href = "/";
          }
        });
    }
    helper.EventListenerForDownloadAndPrintDoc(self);
  },
  methods: {
    ...mapActions(["setShowLayout"]),
    hideChat() {
      var chatElement = document.getElementById("lz_overlay_chat");
      if (chatElement) chatElement.style.display = "none";
    },
  },
};
</script>
